import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  history: null,
  historyPagination: null,

  systems: null,
  currencies: [],
  exchangeRate: null,

  orderId: null,
  swiftUrl: null,

  processingUrl: null,
  depositStatus: '',
};

export const depositSlice = createSlice({
  name: 'deposit',
  initialState,
  reducers: {
    setDepositHistory: (state, action) => {
      state.history = action.payload;
    },
    setDepositHistoryPagination: (state, action) => {
      state.historyPagination = action.payload;
    },

    setDepositSystems: (state, action) => {
      state.systems = action.payload;
    },
    setDepositCurrencies: (state, action) => {
      state.currencies = action.payload;
    },
    setDepositExchangeRate: (state, action) => {
      state.exchangeRate = action.payload;
    },

    setDepositOrderId: (state, action) => {
      state.orderId = action.payload;
    },

    setDepositProcessingUrl: (state, action) => {
      state.processingUrl = action.payload;
    },
    setDepositSwiftUrl: (state, action) => {
      state.swiftUrl = action.payload;
    },
    setDepositStatus: (state, action) => {
      state.depositStatus = action.payload;
    },

    resetDeposit: () => initialState,
  },
});

export const {
  setDepositHistory,
  setDepositHistoryPagination,

  setDepositSystems,
  setDepositCurrencies,
  setDepositExchangeRate,

  setDepositOrderId,

  setDepositProcessingUrl,
  setDepositSwiftUrl,
  setDepositStatus,

  resetDeposit,
} = depositSlice.actions;

export default depositSlice.reducer;
